export default function grantsAiAccess(isFeatureEnabled) {
  return isFeatureEnabled('aiPermissions') && isFeatureEnabled('ai:read');
}
